var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTechwork2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.582,
    height: 66.234,
    viewBox: "0 0 42.582 66.234",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15109",
    "data-name": "Group 15109",
    transform: "translate(-845.023 -210.262)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41122",
    "data-name": "Path 41122",
    d: "M851.717,263.445a1.722,1.722,0,0,1-.771-1.707,8.008,8.008,0,0,0-1.542-5.093c-.808-1.247-1.575-2.522-2.458-3.716a9.891,9.891,0,0,1-1.907-6.618c.263-5.078.467-10.156.295-15.242a7.707,7.707,0,0,1,.1-1.546,4.913,4.913,0,0,1,6.581-3.664,5.5,5.5,0,0,1,1.218.586,16.414,16.414,0,0,0,6.77,2.348c.552.089,1.108.161,1.659.252a1.2,1.2,0,0,1,1.118,1.39,3.422,3.422,0,0,1-2.044,3.127,8.813,8.813,0,0,1-5.981.6,10.684,10.684,0,0,1-2.608-.923,3.432,3.432,0,0,1-1.344-1.173,1.178,1.178,0,1,0-2,1.242,1.32,1.32,0,0,0,.291.424,2.251,2.251,0,0,1,.693,2.076c-.02,4.352-.011,8.7-.009,13.055a4.72,4.72,0,0,0,5.043,5.054q8.754.011,17.512,0h.7c.067.271-.143.33-.254.426a18.481,18.481,0,0,1-3.214,2.267,3.721,3.721,0,0,0-2.063,3.6c.013.539-.035,1.081.011,1.616a1.587,1.587,0,0,1-.8,1.622Z",
    transform: "translate(0 13.05)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41123",
    "data-name": "Path 41123",
    d: "M866.681,237.235a9.97,9.97,0,0,0,3.162-5.25c.638-2.867.465-5.627-1.4-8.055a7.157,7.157,0,0,0-7.293-2.871,7.036,7.036,0,0,0-5.818,5.084,10.1,10.1,0,0,0,2.463,10.618c.361.38.419.534-.1.777a7,7,0,0,0-1.887,1.344.785.785,0,0,1-.813.219,10.1,10.1,0,0,1-3.16-1.264,10.22,10.22,0,0,0-2.61-1.249.434.434,0,0,1-.367-.508c.015-.278,0-.56,0-.84q0-11.053,0-22.106c0-1.953.888-2.78,2.837-2.867a1.451,1.451,0,0,1,1.716,1.092,13.416,13.416,0,0,0,.71,1.447,3.571,3.571,0,0,0,3.421,2.22q4.912.028,9.824,0a3.589,3.589,0,0,0,3.432-2.205c.345-.717.721-1.42,1.058-2.141a.575.575,0,0,1,.641-.395c.321.028.645.006.967.007a2.378,2.378,0,0,1,2.595,2.561c.017,2.113,0,4.224,0,6.335q0,10.278.009,20.555a1.154,1.154,0,0,1-.519,1.064,4.6,4.6,0,0,0-.669,6.789c.359.4.311.584-.02.956a4.593,4.593,0,0,0,.039,6.181c.315.354.317.513,0,.867a4.6,4.6,0,0,0,.674,6.835c.432.326.406.567.18.947a2.287,2.287,0,0,1-2,1.218c-.969.022-1.938.007-2.908.009q-9.633,0-19.261,0a2.42,2.42,0,0,1-2.732-2.747c0-4.094.011-8.186-.013-12.28,0-.6.148-.691.677-.471a8.263,8.263,0,0,0,2.311.569c.539.052.617.287.6.741-.028.752-.013,1.509-.006,2.261a2.314,2.314,0,0,0,2.482,2.517q7.564.014,15.125,0a2.313,2.313,0,0,0,2.469-2.47c.009-1.744-.035-3.49.009-5.234A10.72,10.72,0,0,0,866.681,237.235Zm-4.25,25.06c2.109,0,4.22,0,6.329,0,.862,0,1.4-.469,1.394-1.179s-.549-1.168-1.412-1.168q-6.263-.006-12.53,0c-.871,0-1.4.445-1.42,1.156-.017.736.523,1.19,1.438,1.192C858.3,262.3,860.365,262.3,862.431,262.3Z",
    transform: "translate(3.267 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41124",
    "data-name": "Path 41124",
    d: "M854.139,226.617a7.347,7.347,0,0,1,6.451-.5,7.926,7.926,0,0,1,5.052,7.237c.03,1.961,0,3.92.017,5.881.005.43-.128.571-.547.536-.576-.05-1.31.226-1.69-.106s-.113-1.1-.13-1.666c-.026-.9,0-1.809-.011-2.713-.011-.877-.458-1.4-1.168-1.414-.728-.013-1.2.545-1.208,1.444-.007,1.314-.015,2.628.006,3.94.006.384-.094.523-.5.517q-2.455-.031-4.909,0c-.417.007-.5-.156-.495-.526q.025-1.907,0-3.812a.962.962,0,0,1,.347-.78,6.255,6.255,0,0,0,1.907-3.514C857.677,228.808,856.6,227.19,854.139,226.617Z",
    transform: "translate(7.779 13.081)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41125",
    "data-name": "Path 41125",
    d: "M858.642,227.815a4.592,4.592,0,0,1-3.573-1.553,6.365,6.365,0,0,1-1.023-1.559,3.068,3.068,0,0,1-.536-1.69c.124-.595.947-.447,1.451-.651a15.092,15.092,0,0,0,3.612-1.963.751.751,0,0,1,.873-.107q1.913.856,3.851,1.649a.493.493,0,0,1,.354.673,7.743,7.743,0,0,1-1.564,3.492A4.435,4.435,0,0,1,858.642,227.815Z",
    transform: "translate(7.226 8.48)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41126",
    "data-name": "Path 41126",
    d: "M867.638,232.223c-.58,0-1.162.013-1.742,0a2.337,2.337,0,0,1-2.346-2.2,2.271,2.271,0,0,1,2.083-2.493,23.745,23.745,0,0,1,4.059,0,2.3,2.3,0,0,1,2.107,2.42,2.362,2.362,0,0,1-2.354,2.27C868.842,232.236,868.24,232.223,867.638,232.223Z",
    transform: "translate(15.804 14.661)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41127",
    "data-name": "Path 41127",
    d: "M852.457,210.293h13.85a10.852,10.852,0,0,1-1,1.931,1.045,1.045,0,0,1-.914.393q-5.007,0-10.017,0a1.057,1.057,0,0,1-.986-.508C853.065,211.538,852.785,210.938,852.457,210.293Z",
    transform: "translate(6.343 0.027)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41128",
    "data-name": "Path 41128",
    d: "M867.09,231.317a12.052,12.052,0,0,1,1.418.007,2.358,2.358,0,0,1-.057,4.693,18.625,18.625,0,0,1-2.709,0,2.307,2.307,0,0,1-2.2-2.411,2.348,2.348,0,0,1,2.318-2.3c.408-.022.817,0,1.227,0Z",
    transform: "translate(15.804 17.943)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41129",
    "data-name": "Path 41129",
    d: "M866.665,235.125a4.067,4.067,0,0,1,1.042.085,2.364,2.364,0,0,1,1.764,2.335,2.328,2.328,0,0,1-1.868,2.244,6.033,6.033,0,0,1-1.991.037,2.3,2.3,0,0,1-2.066-2.454,2.347,2.347,0,0,1,2.3-2.246C866.083,235.114,866.319,235.125,866.665,235.125Z",
    transform: "translate(15.804 21.212)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41130",
    "data-name": "Path 41130",
    d: "M864.824,223.725c0-.643.035-1.29-.013-1.931a.692.692,0,0,1,.586-.823,6.252,6.252,0,0,1,1.714-.513,2.374,2.374,0,0,1,2.352,1.74,2.3,2.3,0,0,1-1.164,2.68c-1.021.5-2.092.89-3.136,1.338-.361.156-.339-.07-.339-.3Z",
    transform: "translate(16.882 8.7)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41131",
    "data-name": "Path 41131",
    d: "M858.716,217.3a5.113,5.113,0,0,1,1.581.263c.293.1.332.195.126.436a14.382,14.382,0,0,1-6.492,4.7c-.449.145-.6.12-.558-.413A5.3,5.3,0,0,1,858.716,217.3Z",
    transform: "translate(7.119 6.009)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41132",
    "data-name": "Path 41132",
    d: "M854.444,233.191c-.041.445.239,1.169-.1,1.51-.367.372-1.1.061-1.672.133-.506.065-.656-.148-.588-.612.022-.148,0-.3.005-.452.033-.662-.28-1.523.124-1.927.387-.389,1.245-.293,1.888-.449.282-.069.343.019.339.267C854.438,232.135,854.444,232.607,854.444,233.191Z",
    transform: "translate(5.962 18.014)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41133",
    "data-name": "Path 41133",
    d: "M860.227,221.132c-.865-.371-1.625-.714-2.4-1.021-.348-.139-.3-.269-.089-.493.339-.358.675-.721.982-1.106.2-.248.326-.2.48.03A5.793,5.793,0,0,1,860.227,221.132Z",
    transform: "translate(10.709 6.899)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechwork2);
export default __webpack_public_path__ + "static/media/techwork2.0c6be82d09578ae06ff3f9c6b0b76024.svg";
export { ForwardRef as ReactComponent };